import { MixpanelEventSource } from '@talos/kyoko';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTransfersDrawer } from '../../hooks';

export const TransfersRouteRedirect = () => {
  const { openTransfersDrawer } = useTransfersDrawer();
  const navigate = useNavigate();
  const hasOpenedRef = useRef(false);

  useEffect(() => {
    if (hasOpenedRef.current) {
      return;
    }

    hasOpenedRef.current = true;
    openTransfersDrawer({ source: MixpanelEventSource.TransferBlotter });
    navigate('/trading', { replace: true });
  }, [navigate, openTransfersDrawer]);

  return null;
};
